import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { PasscodeDialog } from "@/components/PasscodeDialog";

const menu = [
  { to: "/", label: "Home", id: "footer-home-link" },
  { to: "/contact", label: "Contact Us", id: "footer-support-link" },
  { to: "/privacy-policy", label: "Privacy Policy & Data Protection", id: "footer-privacy-link" },
];

export const Footer = () => {
  const [adminOpen, setAdminOpen] = useState(false);
  return (
  <footer className="border-t border-line/70" data-testid="site-footer">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-12">
      <div className="md:col-span-5">
        <div className="flex items-center">
          <img src="/x-mark.png" alt="X" className="h-9 w-auto object-contain" />
          <span className="-ml-1 text-[21px] font-semibold tracking-tight text-body">pattern</span>
        </div>
        <p className="mt-4 max-w-sm text-sm leading-relaxed text-muted">
          Automotive pattern cutting software for professional installers. Any vehicle, precise cuts, fair pricing.
        </p>
      </div>

      <div className="md:col-span-3">
        <p className="mono-label">Menu</p>
        <ul className="mt-5 space-y-3" data-testid="footer-menu">
          {menu.map((m) => (
            <li key={m.to}>
              <Link to={m.to} className="text-sm text-muted transition-colors hover:text-body" data-testid={m.id}>
                {m.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="md:col-span-4">
        <p className="mono-label">Xpattern</p>
        <ul className="mt-5 space-y-3 text-sm text-muted" data-testid="footer-contact">
          <li className="flex items-start gap-3"><MapPin size={16} className="mt-0.5 shrink-0 text-blue-text" /> Portland, Oregon</li>
          <li className="flex items-center gap-3">
            <Mail size={16} className="shrink-0 text-blue-text" />
            <a href="mailto:support@xpattern.net" className="transition-colors hover:text-body" data-testid="footer-email-link">support@xpattern.net</a>
          </li>
          <li className="flex items-center gap-3">
            <Phone size={16} className="shrink-0 text-blue-text" />
            <a href="tel:+15033284130" className="transition-colors hover:text-body" data-testid="footer-phone-link">503.328.4130</a>
          </li>
        </ul>
        <Link to="/contact" className="btn btn-secondary mt-6 !px-5 !py-2.5 text-sm" data-testid="footer-contact-button">
          Contact Us
        </Link>
      </div>
    </div>

    <div className="border-t border-line/70">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-5 py-5 text-xs text-muted sm:flex-row sm:px-8">
        <button type="button" onClick={() => setAdminOpen(true)} className="cursor-default text-left transition-colors hover:text-silver" data-testid="footer-rights">
          All Rights Reserved © {new Date().getFullYear()} Xpattern
        </button>
        <p>Automotive pattern software</p>
      </div>
    </div>
    <PasscodeDialog open={adminOpen} onClose={() => setAdminOpen(false)} />
  </footer>
  );
};
